module.exports = __webpack_public_path__ + "img/askmebet-support.76dfb801.png";